import e from "./ghl-ui.es1157.js";
const n = (o) => {
  const {
    textColor1: t,
    dividerColor: i,
    fontWeightStrong: r
  } = o;
  return {
    textColor: t,
    color: i,
    fontWeight: r
  };
}, d = {
  name: "Divider",
  common: e,
  self: n
}, m = d;
export {
  m as default,
  n as self
};
